module.exports = __webpack_public_path__ + "static/media/gli_03.5f1a662a.png";